import { render } from "./TikTok.vue?vue&type=template&id=289b78d4&scoped=true"
import script from "./TikTok.vue?vue&type=script&lang=js"
export * from "./TikTok.vue?vue&type=script&lang=js"

import "./TikTok.vue?vue&type=style&index=0&id=289b78d4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289b78d4"]])

export default __exports__